import ButtonNuitrackAnalyticsServiceRedirect from './ButtonNuitrackAnalyticsServiceRedirect';

export default ButtonNuitrackAnalyticsServiceRedirect;
